import {useMemo, useState, useEffect} from 'react'
import {Pagination} from 'react-bootstrap'
import {useIntl, FormattedMessage} from 'react-intl'
import {KTIcon} from '../../../_metronic/helpers'
import {useParams} from 'react-router-dom'
import {useTable, usePagination} from 'react-table'
import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import usePageTitle from '../custom_hooks/usePageTitle'
import TemplatesKMmain from '../know_more_modals/TemplatesKMModal'
import {CheckPodAccess, FindFirstPodCode, FindPodIdByCode} from '../FindPodIdByPodCode'
import secureLocalStorage from 'react-secure-storage'
import usePostApi from '../custom_hooks/usePostApi'
import {UseToast} from '../useToast'
import TemplatesKM from '../know_more_modals/templates_KM/TemplatesKM'
import {defaultProfileImage} from '../core'
import DateFormatter from '../DateFormatter'
import {PrimaryOutlineButton} from '../../ui/PrimaryOutlineButton'
import {useThemeMode} from '../../../_metronic/partials'
import CryptoJS from 'crypto-js'
import {LightOutlineButton} from '../../ui/LightOutlineButton'

const secretKey = process.env.REACT_APP_REQUEST_SIGN_SECRET_KEY

const DataTable = ({columns, data, isLoading, fetchData, refresh}) => {
  const mode = useThemeMode()
  const havePodAccess = CheckPodAccess()
  const firstPodCode = FindFirstPodCode()
  const [showModal, setShowModal] = useState(false)
  const userInfo = secureLocalStorage.getItem('user_info')
  let user_id = ''
  let auth_token = ''
  if (userInfo) {
    ;({user_id, auth_token} = userInfo)
  }
  usePageTitle('Template')
  const podId = FindPodIdByCode()
  const intl = useIntl()
  const {id} = useParams()
  const Onboardings = [
    {
      title: `(${id})`,
      path: `/${id}/templates`,
      isSeparator: false,
      isActive: false,
    },
  ]

  const [inputVal, setInputVal] = useState('')
  const [currentStatus, setCurrentStatus] = useState('Active')

  const filteredData = useMemo(() => {
    return data
      ? data.filter((each) => {
          const status = each.is_active === 1 ? 'Active' : 'Inactive'
          const nameMatches =
            each.doc_title && each.doc_title.toLowerCase().includes(inputVal.toLowerCase())
          const currentStatusMatches =
            status && status.toLowerCase() === currentStatus.toLowerCase()

          return nameMatches
        })
      : []
  }, [inputVal, data, currentStatus])

  const tableInstance = useTable({columns, data: filteredData}, usePagination)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: {pageIndex, pageSize},
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageCount,
    gotoPage,
    setPageSize,
  } = tableInstance

  const pageOptions = [10, 20, 30, 40, 50]

  const payload = {
    pod_id: podId,
    user_id,
    auth_token,
    pod_code: id,
  }

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString()
  const encoded = encodeURIComponent(encrypted)
  const url = `${process.env.REACT_APP_REQUEST_SIGN_PATH}/template-create?data=${encoded}`

  return havePodAccess ? (
    <>
      <TemplatesKMmain showModal={showModal} setShowModal={setShowModal} />
      <PageTitle breadcrumbs={Onboardings}>Templates</PageTitle>
      {isLoading && refresh === false ? (
        <div className='card h-250px'>
          <div className='m-auto d-flex flex-column align-items-center'>
            <div className='spinner-border spinner-primary mr-15'></div>
          </div>
        </div>
      ) : data && data.length > 0 ? (
        <>
          <div className='d-flex flex-wrap flex-stack '>
            <div className='d-flex'>
              <h1 className='fs-3 fw-semibold'>Manage Templates</h1>
            </div>
            <div className='d-flex'>
              <div className='m-auto d-flex flex-column align-items-center'>
                <button
                  className='btn btn-sm btn-light fw-normal'
                  onClick={() => setShowModal(true)}
                >
                  <i className='ki-duotone ki-information-3 fs-3'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                  Know More
                </button>
              </div>
            </div>
          </div>
          <p className='fs-6 text-gray-600 mb-4'>
            Seamlessly create, update templates, ensuring no details are overlooked during the
            hiring process.
          </p>
          {refresh ? (
            <div className='card h-250px'>
              <div className='m-auto d-flex flex-column align-items-center'>
                <div className='spinner-border spinner-primary mr-15'></div>
              </div>
            </div>
          ) : (
            <>
              <div className='card p-5 mb-5'>
                <div className='d-flex flex-column flex-md-row justify-content-md-between border-0 px-0 mb-5'>
                  <ul className='nav d-flex align-items-center'>
                    <li className='nav-item'>
                      <span
                        className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-success fw-normal px-4 me-1 ${
                          currentStatus === 'Active' ? 'active' : ''
                        }`}
                        data-bs-toggle='tab'
                        onClick={() => setCurrentStatus('Active')}
                      >
                        {intl.formatMessage({id: 'LABEL.ACTIVE'})}
                      </span>
                    </li>
                    <li className='nav-item'>
                      <span
                        className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-danger fw-normal px-4 me-1 ${
                          currentStatus === 'Inactive' ? 'active' : ''
                        }`}
                        data-bs-toggle='tab'
                        onClick={() => setCurrentStatus('0')}
                      >
                        {intl.formatMessage({id: 'LABEL.INACTIVE'})}
                      </span>
                    </li>
                  </ul>

                  <div className='d-flex flex-wrap gap-3'>
                    <div className='d-flex align-items-center position-relative'>
                      <KTIcon iconName='magnifier' className='fs-3 position-absolute ms-3' />
                      <input
                        type='search'
                        id='kt_filter_search'
                        className='form-control form-control-white form-control-sm w-150px ps-9 fw-normal'
                        placeholder={intl.formatMessage({id: 'LABEL.SEARCH'})}
                        value={inputVal}
                        onChange={(e) => setInputVal(e.target.value)}
                        autoComplete='off'
                      />
                    </div>

                    <a
                      // href={`https://boltsign-requests.vercel.app/template-create?p=${podId}&u=${user_id}&t=${auth_token}&c=${id}`}
                      href={url}
                      target='_blank'
                      className={`btn btn-sm bg-${
                        mode === 'dark' ? 'secondary' : 'white'
                      } btn-outline border-primary text-primary btn-active-light-primary d-flex align-items-center`}
                      // onClick={() => setAddModal(true)}
                    >
                      <KTIcon iconName='plus' className='fs-3 text-primary' />
                      Create
                    </a>

                    <LightOutlineButton
                      className='btn btn-sm btn-bg-light fw-normal px-3 pe-2 btn-active-primary'
                      onClick={() => fetchData(true)}
                    >
                      <i className='ki-solid ki-arrows-circle fs-3'></i>
                    </LightOutlineButton>
                  </div>
                </div>

                <div className='mb-0'>
                  <div className='overflow-auto'>
                    <table
                      className='table table-row-dashed table-row-gray-300 align-middle'
                      {...getTableProps()}
                    >
                      <thead>
                        <tr className='fw-semibold text-muted default-cursor bg-light rounded'>
                          <th className='min-w-150px ps-3'>Document Title</th>
                          <th className='min-w-100px'>Status</th>
                          <th className='min-w-150px'>Created At</th>
                          <th className='min-w-150px text-center pe-3'>Actions</th>
                        </tr>
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page?.length > 0 ? (
                          page.map((row) => {
                            prepareRow(row)
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => (
                                  <td className='text-center' {...cell.getCellProps()}>
                                    {cell.render('Cell')}
                                  </td>
                                ))}
                              </tr>
                            )
                          })
                        ) : (
                          <tr>
                            <td className='' colSpan={4}>
                              <div className='d-flex justify-content-center'>
                                <p className='text-dark default-cursor fs-6 mt-5'>
                                  {inputVal === '' ? (
                                    intl.formatMessage({id: 'NO_RESULTS_FOUND_MSG'})
                                  ) : (
                                    <FormattedMessage
                                      id='MSG.NO_DATA_MATCH'
                                      values={{
                                        inputVal: <span className='text-primary'>{inputVal}</span>,
                                      }}
                                    />
                                  )}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {data?.length > 10 && (
                <Pagination>
                  <Pagination.First onClick={() => gotoPage(0)} disabled={!canPreviousPage} />
                  <Pagination.Prev onClick={previousPage} disabled={!canPreviousPage} />

                  {[...Array(pageCount)].map((_, i) => (
                    <Pagination.Item key={i} active={i === pageIndex} onClick={() => gotoPage(i)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next onClick={nextPage} disabled={!canNextPage} />
                  <Pagination.Last
                    onClick={() => gotoPage(pageCount - 1)}
                    disabled={!canNextPage}
                  />

                  <div className='d-flex align-items-center mx-5'>
                    <span className='me-2'>Show</span>
                    <select
                      className='form-select form-select-solid fw-semibold w-75px me-2'
                      value={pageSize}
                      onChange={(e) => setPageSize(Number(e.target.value))}
                    >
                      {pageOptions.map((option) => (
                        <option key={option} value={option} className='select-bg'>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                </Pagination>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <h3 className='fs-3 fw-semibold'>Creating Templates with Drag-and-Drop Ease</h3>

          <p className=''>
            Welcome to the Template Page! This section empowers you to seamlessly create, manage,
            and customize templates to suit your needs. Explore the intuitive drag-and-drop
            functionality to design templates effortlessly.
          </p>

          <div className='text-center mb-4'>
            <TemplatesKM />

            {/* <a
              href={`https://boltsign-requests.vercel.app/template-create?p=${podId}&u=${user_id}&t=${auth_token}&c=${id}`}
              target='_blank'
              className='btn btn-sm btn-light-primary'
            >
              <KTIcon iconName='plus' className='fs-3' />
              Create
            </a> */}
            {/* <PrimaryOutlineButton
              className='m-auto'
              onClick={() => window.location.replace(url)}
              iconName='plus'
            >
              Create
            </PrimaryOutlineButton> */}

            <div className='d-flex justify-content-center align-items-center'>
              <a
                href={url}
                target='_blank'
                className={`btn btn-sm bg-${
                  mode === 'dark' ? 'secondary' : 'white'
                } btn-outline border-primary text-primary btn-active-light-primary d-flex align-items-center`}
              >
                <KTIcon iconName='plus' className='fs-3 text-primary' />
                Create
              </a>
            </div>
          </div>
        </>
      )}
    </>
  ) : (
    <div className='card min-h-250px d-flex flex-column justify-content-center align-items-center bg-image'>
      <h1 className='fw-semibold fs-2hx text-gray-900 mb-4'>Oops!</h1>
      <div className='fs-6 text-gray-500 mb-7'>You don't have access to this POD.</div>
      <div className='mb-0'>
        <Link to={`/${firstPodCode}/dashboard`} className='btn btn-sm btn-light-primary'>
          Return Home
        </Link>
      </div>
    </div>
  )
}

const TemplatesMain = () => {
  const {execute, loading: isLoading} = usePostApi()
  const podId = FindPodIdByCode()
  const templateCanvasAppUrl = process.env.REACT_APP_TEMPLATE_CANVAS_APP_URL
  const userInfo = secureLocalStorage.getItem('user_info')
  let user_id = ''
  let auth_token = ''
  if (userInfo) {
    ;({user_id, auth_token} = userInfo)
  }

  const [refresh, setRefresh] = useState(false)

  const [templates, setTemplates] = useState([])
  const getTemplates = async (show) => {
    if (show) {
      setRefresh(true)
    }
    try {
      const url = '/document/template/get'
      const formData = {
        pod_id: podId,
      }

      const response = await execute(url, 'POST', formData)
      setTemplates(response.data)
      setRefresh(false)
      if (show) {
        return UseToast(
          response.status_message,
          {
            position: 'bottom-right',
            theme: 'colored',
            autoClose: true,
          },
          'success'
        )
      }
    } catch (error) {
      console.error('Error:', error)
      setRefresh(false)
      if (show) {
        return UseToast(
          error.response?.data?.status_message,
          {
            position: 'bottom-right',
            theme: 'colored',
            autoClose: true,
          },
          'error'
        )
      }
    }
  }

  useEffect(() => {
    getTemplates()
  }, [])

  const {id} = useParams()

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: ({row}) => {
          return (
            <div className='d-flex align-items-center ps-3'>
              <div className='symbol symbol-50px me-5'>
                <img src={row.original.profile_pic || defaultProfileImage} alt='' />
              </div>
              <div className='d-flex justify-content-start flex-column text-start'>
                <p className='text-dark fw-semibold text-hover-primary mb-1 fs-6 default-cursor'>
                  {row.original.doc_title}
                </p>
              </div>
            </div>
          )
        },
        disableSortBy: true,
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({row}) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column text-start'>
                <p className='text-dark fw-semibold text-hover-primary mb-1 fs-6 default-cursor'>
                  {row.original?.status || '-'}
                </p>
              </div>
            </div>
          )
        },
        disableSortBy: true,
      },
      {
        Header: 'CreatedAt',
        accessor: 'created_at',
        Cell: ({row}) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column text-start'>
                <p className='text-dark fw-semibold text-hover-primary mb-1 fs-6 default-cursor'>
                  {row.original.created_timestamp
                    ? DateFormatter(row.original.created_timestamp)
                    : ''}
                  {row.original.created_timestamp && ', '}

                  {row.original.created_timestamp &&
                    row.original.created_timestamp.length >= 16 &&
                    row.original.created_timestamp.slice(11, 16)}
                </p>
              </div>
            </div>
          )
        },
        disableSortBy: true,
      },

      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({row}) => {
          return (
            <div className='text-center'>
              <a
                href={row.original?.doc_metadata?.document_url}
                target='_blank'
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                rel='noreferrer'
                type='application/pdf'
              >
                <KTIcon iconName='document' className='fs-3' />
              </a>
              {/* <Link
                to={`${row.original.request_id}`}
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
              >
                <KTIcon iconName='eye' className='fs-3' />
              </Link> */}
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <DataTable
      columns={columns}
      data={templates ?? []}
      isLoading={isLoading}
      fetchData={getTemplates}
      refresh={refresh}
    />
  )
}

export default TemplatesMain
